import { useUserActions } from 'shared/auth/hooks/useUserActions';
import { useFeatureFlags } from 'shared/providers/FeatureFlags/useFeatureFlags';

export const REPORTS_PATH = '/npo/reports';
export const PROGRAMS_AND_REPORTS_PATH = '/npo/programs-and-reports';

export interface ProgramsAndReports {
  enabled: boolean;
  path: string;
}

/**
 * Single source of truth for the Programs & Reports rollout. It replaces the
 * legacy Reports page when the `programsAndReports` flag is on, or for BB
 * partner users. CN users only get it via the flag (same as everyone else).
 *
 * Use this anywhere that routes to, links to, or gates the Reports page so the
 * nav tab, the registered route, and deep links can never diverge.
 */
export function useProgramsAndReports(): ProgramsAndReports {
  const { isBBUser } = useUserActions();
  const enabled = useFeatureFlags('programsAndReports') || isBBUser;
  return {
    enabled,
    path: enabled ? PROGRAMS_AND_REPORTS_PATH : REPORTS_PATH,
  };
}
